import { useNavigate } from '@tanstack/react-router';
import { Interaction, InteractionType } from '@momentum/types';
import { WizardState } from '@/features/wizard';

type NavigateFunction = ReturnType<typeof useNavigate>;

interface HandleInteractionRowClickArgs {
  interaction: Interaction;
  navigate: NavigateFunction;
}

export const handleInteractionRowClick = ({
  interaction,
  navigate,
}: HandleInteractionRowClickArgs): void => {
  if (interaction.isDraft) {
    const state: WizardState = {
      currentStepId: '',
      isCompleted: true,
      language: 'en',
      answers: interaction.formData,
    };
    const sessionState = {
      history: [],
      state,
    };

    switch (interaction.type) {
      case InteractionType.PRAISE:
        sessionStorage.setItem(
          'praise-questions-wizard',
          JSON.stringify(sessionState)
        );
        navigate({
          to: '/interactions/PraiseWizard',
          search: { employeeId: undefined, interactionId: interaction._id },
        });
        break;
      case InteractionType.FEEDBACK:
        sessionStorage.setItem(
          'feedback-questions-wizard',
          JSON.stringify(sessionState)
        );
        navigate({
          to: '/interactions/FeedbackWizard',
          search: { employeeId: undefined, interactionId: interaction._id },
        });
        break;
      case InteractionType.DEBRIEF: {
        navigate({
          to: '/interactions/DebriefWizard',
          search: {
            debriefid: interaction._id,
            interactionId: interaction._id,
          },
        });
        break;
      }
    }
    return;
  }

  switch (interaction.type) {
    case InteractionType.PRAISE:
      navigate({
        to: '/interactions/praise/$id',
        params: { id: interaction._id },
      });
      break;
    case InteractionType.FEEDBACK:
      navigate({
        to: '/interactions/feedback/$id',
        params: { id: interaction._id },
      });
      break;
    case InteractionType.DEBRIEF:
      navigate({
        to: '/interactions/debrief/$id',
        params: { id: interaction._id },
      });
      break;
    default:
      break;
  }
};
